import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = import.meta.env.VITE_URL || import.meta.env.VITE_URL2;

const getErrorMessage = (error) => {
  if (axios.isAxiosError(error))
    return error.response?.data?.message || error.message;
  return error.message;
};

// 1. Verify Email
export const verifyRegisterEmail = createAsyncThunk(
  "forget/registeredEmail",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/forget/verifyemail`, {
        params: payload,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// 2. Verify OTP
export const verifyEmailOTP = createAsyncThunk(
  "forget/EmailOTP",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/forget/verifyOTP`, {
        params: payload,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// 3. Change Password
export const ChangePassword = createAsyncThunk(
  "forget/changePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/api/forget/changePassword`,
        payload
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
